import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Delivery, Examinees, User } from '../app.urls';

@Injectable({
  providedIn: 'root'
})
export class ExamineeloginService {
  public email = new BehaviorSubject<any>('');
  public getEmail = this.email.asObservable();

  public password = new BehaviorSubject<any>('');
  public getPassword = this.password.asObservable();

  public isHeaderVisible$: BehaviorSubject<boolean>;
  constructor(private http: HttpClient) {
    this.isHeaderVisible$ = new BehaviorSubject<boolean>(false);
  }

  login(userName: string, password: string, schId?: any): Observable<any> {
    // const body = new HttpParams()
    // .set('emailId', userName)
    // .set('password', password)
    // .set('testscheduleuuid',schId)
    // .set('DNTCaptchaText', CaptchaTextValue)
    // .set('DNTCaptchaInputText', captchaText)
    // .set('DNTCaptchaToken', CaptchaTokenValue)

    // const headers = new HttpHeaders({
    // 'Content-Type': 'application/x-www-form-urlencoded'
    // });


    const loginData = {
      emailId: userName,
      password: password,
      testscheduleuuid: schId
    };
    const loginDataToApi = JSON.stringify(loginData);
    return this.http.post<any>(Delivery.Login, loginDataToApi , { 'headers': {'content-type' : 'application/json'}}).pipe(
        tap((user: any) => {
          if (user && user.data) {
            sessionStorage.setItem('examineeUser', JSON.stringify(user.data));
          }
        })
      );
  }

  publicLogin(scheduleId: string, userJson: string, isGetDemographic?: boolean): Observable<any> {
    const publicLoginData = {
      scheduleId: scheduleId,
      userJson: userJson,
      isGetDemographic: isGetDemographic
    };
    const publicLoginDataToApi = JSON.stringify(publicLoginData);
    return this.http.post<any>(Delivery.PublicLogin, publicLoginDataToApi, { 'headers': { 'content-type': 'application/json' } }).pipe(
        tap((user: any) => {
          if (user && user.body.data) {
            sessionStorage.setItem('examineeUser', JSON.stringify(user.body.data));
          }
        })
      );
  }

  // This funtion is to reset password
  resetPassword(emailId: any) {
    const loginData = {
      "emailId": emailId,
    };
    return this.http.post<any>(Examinees.ResetPassword, JSON.stringify(loginData), { 'headers': { 'content-type': 'application/json' } })
  }

  scheduleDetail(scheduleId: any, patientuuid?: string, language?: any) {
    // const scheduleapiUrl = 'https://ta-api.tanayassessmentdev.com/loginCheck/'+ scheduleId;
    return this.http.get<any>(Delivery.ScheduleDetail + scheduleId + `/${patientuuid}` )
  }

  getCaptcha() {
    return this.http.get<any>(User.Captcha);
  }

  resendAuthenticationCode(payload: any) {
    return this.http.post<any>(Delivery.resendAuthenticationCode + `?email=${payload.emailId}`, payload)
  }

  signIn(payload) {
    return this.http.post<any>(Delivery.Login, payload).pipe(
      tap((user: any) => {
        if (user && user.data) {
          sessionStorage.setItem('examineeUser', JSON.stringify(user.data));
        }
      })
    );
  }

  validateCaptcha(tokenValue: any, textValue: any, inputText: any) {
    const body = new HttpParams()
    .set('DNTCaptchaText', textValue)
    .set('DNTCaptchaInputText', inputText)
    .set('DNTCaptchaToken', tokenValue)

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
      });
      return this.http.post<any>(User.ValidateCaptcha, body.toString(), { headers: headers });
  }

  checkUser(userName: string, password: string, schId: string) {
    return this.http.post<any>(Delivery.UserCheck, { "emailId": userName, "password": password, "testscheduleuuid": schId }, { 'headers': { 'content-type': 'application/json' } });
  }

  changePassword(payload: any) {
    return this.http.post<any>(Delivery.changePassword, payload);
  }

  verfiyAuthCode(payload: any) {
    return this.http.post<any>(Delivery.authCode, payload);
  }
}
